/**
 * Chat Message Constants
 *
 * Welcome messages and translators for the chat interface.
 */

import { createTranslator } from '../../../utils/detectLanguage';
import { welcomeMessagePtBR } from '../../mappings/welcomeMessage.pt-br';
import { welcomeMessageES } from '../../mappings/welcomeMessage.es';

/**
 * Default welcome message in English
 */
export const WELCOME_MESSAGE_EN = "Welcome to PickStar AI - Your Personalized Sports Research Assistant. Ask away!";

/**
 * Translator for welcome message (supports pt-br, es)
 */
export const welcomeTranslator = createTranslator({
  'pt-br': welcomeMessagePtBR,
  'es': welcomeMessageES
});

/**
 * Localized welcome message
 */
export const WELCOME_MESSAGE = welcomeTranslator(WELCOME_MESSAGE_EN);
